import { render, staticRenderFns } from "./technologies.vue?vue&type=template&id=4ac81db7&"
import script from "./technologies.vue?vue&type=script&lang=js&"
export * from "./technologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports